
import { Signal } from "signals";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";

export default class ToggleElement {

    public onChanged: Signal;

    private onButton: FlexiButton;
    private offButton: FlexiButton;

    private checked: boolean;

    constructor() {
        this.onChanged = new Signal();
    }

    public addButton(button: FlexiButton, buttonState: "on" | "off") {
        if (buttonState === "on" && !this.onButton) {
            this.onButton = button;
            this.onButton.on(ButtonEvent.POINTER_UP, this.onButtonHandler);
        } else if (!this.offButton) {
            this.offButton = button;
            this.offButton.on(ButtonEvent.POINTER_UP, this.disabledButtonHandler);
        }

        this.setChecked(true);
    }

    public setChecked(on: boolean) {
        if (this.onButton) {
            this.onButton.setVisible(on);
        }

        if (this.offButton) {
            this.offButton.setVisible(!on);
        }

        this.checked = on;
    }

    public getChecked() {
        return this.checked;
    }

    public setEnabled(enabled: boolean) {
        if (this.onButton) {
            this.onButton.setEnabled(enabled);
        }

        if (this.offButton) {
            this.offButton.setEnabled(enabled);
        }
    }

    public setVisible(visible: boolean) {

        if (visible) {
            if (this.onButton) {
                this.onButton.setVisible(this.checked);
            }

            if (this.offButton) {
                this.offButton.setVisible(!this.checked);
            }
        } else {
            if (this.onButton) {
                this.onButton.setVisible(false);
            }

            if (this.offButton) {
                this.offButton.setVisible(false);
            }
        }
    }

    public destroy() {
        if (this.onButton) {
            this.onButton.off(ButtonEvent.POINTER_UP, this.onButtonHandler);
            this.onButton.destroy();
            this.onButton = null;
        }

        if (this.offButton) {
            this.offButton.off(ButtonEvent.POINTER_UP, this.onButtonHandler);
            this.offButton.destroy();
            this.offButton = null;
        }

        this.onChanged.removeAll();
    }

    private onButtonHandler = () => {
        this.setChecked(false);

        this.onChanged.dispatch();

        SoundManager.event(SoundEvent.toggle_on_press);
    }

    private disabledButtonHandler = () => {
        this.setChecked(true);

        this.onChanged.dispatch();

        SoundManager.event(SoundEvent.toggle_off_press);
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/elements/toggle-element.ts